/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".iframe-wrapper[_ngcontent-%COMP%]{position:relative;padding-bottom:56.25%;padding-top:25px;height:85vh}.iframe-wrapper[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%}.pdfpos[_ngcontent-%COMP%]{padding-top:50px;margin-left:55px}object[_ngcontent-%COMP%]{display:inline-block;width:100vw;height:100vh;min-height:768px}"];
export { styles as styles };
